import { ITimestampRange } from "@faire/web-api/indigofair/data/ITimestampRange";
import { FREE_DUTIES_PROMO_TIME_RANGE } from "@faire/web-api/indigofair/settings/FREE_DUTIES_PROMO_TIME_RANGE";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingFreeDutiesPromoTimeRange = (): ITimestampRange =>
  getSettingValueWithoutAssignment(
    FREE_DUTIES_PROMO_TIME_RANGE,
    ITimestampRange.build({
      start_at: { seconds: 0, nanos: 0 },
      end_at: { seconds: 0, nanos: 0 },
    })
  );
